import { forwardRef } from "react";
import { createBemBlockBuilder } from "@ebsco-ui/utils";
import cn from "classnames";

import "./indeterminate-spinner.scss";

const SIZE = 50;
const THICKNESS = 3;
const RADIUS = (SIZE - THICKNESS) / 2;

export interface IndeterminateSpinnerProps {
  className?: string;
  level: "page" | "component";
}

const IndeterminateSpinner = forwardRef<
  HTMLDivElement,
  IndeterminateSpinnerProps
>(({ className, level }, ref) => {
  const isIe =
    typeof window !== "undefined" &&
    (navigator.userAgent.indexOf("MSIE") !== -1 ||
      navigator.appVersion.indexOf("Trident/") > -1);

  const browserClassName = isIe
    ? "eb-indeterminate-spinner-ie-11"
    : "eb-indeterminate-spinner";

  const getBlocksWith = createBemBlockBuilder([browserClassName, className]);

  return (
    <div
      className={getBlocksWith()}
      data-auto="indeterminate-spinner"
      ref={ref}
    >
      {isIe ? (
        <div
          className={cn(
            getBlocksWith("__ring"),
            getBlocksWith(`__ring--${level}`),
          )}
        >
          <div />
          <div />
          <div />
          <div />
        </div>
      ) : (
        <svg
          className={cn(
            getBlocksWith("__svg"),
            getBlocksWith(`__svg--${level}`),
          )}
          viewBox={`${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`}
        >
          <circle cx={SIZE} cy={SIZE} r={RADIUS} />
        </svg>
      )}
    </div>
  );
});

IndeterminateSpinner.displayName = "IndeterminateSpinner";

export default IndeterminateSpinner;
